import { FunctionComponent } from 'react';
import { EuiLoadingChart } from '@elastic/eui';
import { css } from '@emotion/react';

export type Props = {
  show: boolean;
};

const Spinner: FunctionComponent<Props> = ({ show }) => {
  if (!show) return null;

  return (
    <div
      css={css`
        width: 100vw;
        height: 100vh;
        background: #ffffff80;
        display: flex;
        justify-content: center;
        alignitems: center;
        z-index: 99;
        position: fixed;
      `}>
      <EuiLoadingChart mono size="xl" />
    </div>
  );
};

export default Spinner;
